// extracted by mini-css-extract-plugin
module.exports = {"container":"shareToNew_container___ba60","myicon":"shareToNew_myicon__Fjens"};